<svelte:options customElement={{ tag: 'vv-petitions', shadow: 'none' }} />

<script context="module">
    import appCssUrl from '../../app.css?inline';
    let style = '<style' + `>${appCssUrl}</style>`;
</script>

<script lang="ts">
    import { onMount } from 'svelte';
    import Router from 'svelte-spa-router';
    import { wrap } from 'svelte-spa-router/wrap';
    import Index from "./Index.svelte";
    import SignPage from "./SignPage.svelte";
    import ConfirmationPage from "./ConfirmationPage.svelte";
    import { vvSettings } from "../../api/common";

    function redirectLegacyHashToServerRoute(): boolean {
        const hash = window.location.hash || '';
        const trimmed = hash.startsWith('#') ? hash.substring(1) : hash;
        const [path, query = ''] = trimmed.split('?');
        const signMatch = path.match(/^\/Sign\/(\d+)$/i);
        const confirmationMatch = path.match(/^\/Confirmation\/(\d+)$/i);
        if (!signMatch && !confirmationMatch) return false;

        const association = (vvSettings as any)?.associationIdName;
        if (!association) return false;
        const siteNumber = (vvSettings as any)?.siteNumber;
        const siteSegment = siteNumber ? `/${siteNumber}` : '';
        const petitionId = signMatch ? signMatch[1] : confirmationMatch![1];
        const actionPath = signMatch ? 'Respond' : 'ConfirmResponse';
        const queryString = query ? `?${query}` : '';
        window.location.replace(`/${association}${siteSegment}/Petitions/${petitionId}/${actionPath}${queryString}`);
        return true;
    }

    let initialHashWasInjected = false;

    if (redirectLegacyHashToServerRoute()) {
        // Full-page redirect kicked off; skip SPA hash initialization.
    } else {
        const initialRoute = (vvSettings as any)?.initialRoute as string | undefined;
        if ((!window.location.hash || window.location.hash === '#') && initialRoute) {
            // Use replaceState (not `window.location.hash = ...`) to put the route fragment in the
            // URL synchronously. Assigning to location.hash queues a `hashchange` event that fires
            // asynchronously after the current task; if we then strip the hash in onMount, that
            // queued event will run *after* the strip, fire getLocation() with an empty hash, and
            // navigate the router to '/' (rendering Index). replaceState updates the URL without
            // firing hashchange, so svelte-spa-router only reads the route once during its initial
            // store subscription and stays there.
            const hashUrl = window.location.pathname + window.location.search + `#${initialRoute}`;
            history.replaceState(history.state, '', hashUrl);
            initialHashWasInjected = true;
        }
    }

    const routes = {
        '/': Index,
        '/Sign/:id': wrap({
            component: SignPage,
        }),
        '/Confirmation/:id': wrap({
            component: ConfirmationPage,
        }),
        // Fallback to Index for any unmatched routes
        '*': Index
    };

    onMount(() => {
        // Strip the hash from the URL bar once the router has consumed it. svelte-spa-router only
        // updates its store on `hashchange`, and history.replaceState does not fire that event,
        // so the matched route is preserved while the canonical /Respond or /ConfirmResponse URL
        // stays clean. All internal navigation in petition routes uses full-page redirects, so
        // the router never needs to mutate the hash again.
        if (initialHashWasInjected) {
            history.replaceState(history.state, '', window.location.pathname + window.location.search);
        }
    });
</script>

{@html style}

<div class="interfont">
    <Router {routes} />
</div>
